import AjaxService from '../services/ajax-service';

import { normalizeDateForServer } from '../utils/date';

export const fetchTimeEntries = ({ projectId, taskId, userId, type = 'all', limit, offset }) => {
    return AjaxService({
        method: 'get',
        url: `time`,
        params: {
            project_id: projectId,
            task_id: taskId,
            user_id: userId,
            type,
            limit,
            offset
        }
    }).then(response => response?.data);
}

export const createTimeEntry = ({ project, task, description, start, end }) => {
    return AjaxService({
        method: 'post',
        url: `time`,
        data: {
            project_id: project,
            task_id: task,
            start_date: normalizeDateForServer(start),
            end_date: normalizeDateForServer(end),
            description
        }
    }).then(response => response?.data);
}

export const startTimeEntry = ({ project, task, description }) => {
    return AjaxService({
        method: 'post',
        url: `time/start`,
        data: {
            project_id: project,
            task_id: task,
            description
        }
    }).then(response => response?.data);
}

export const fetchTimeEntry = timeEntryId => {
    return AjaxService({
        method: 'get',
        url: `time/${timeEntryId}`
    }).then(response => response?.data);
}

export const stopTimeEntry = timeEntryId => {
    return AjaxService({
        method: 'post',
        url: `time/${timeEntryId}/stop`
    }).then(response => response?.data);
}

export const updateTimeEntry = (timeEntryId, { start, end, task, description }) => {
    return AjaxService({
        method: 'put',
        url: `time/${timeEntryId}`,
        data: {
            start: normalizeDateForServer(start),
            end: normalizeDateForServer(end),
            task_id: task,
            description
        }
    }).then(response => response?.data);
}

export const removeTimeEntry = timeEntryId => {
    return AjaxService({
        method: 'delete',
        url: `time/${timeEntryId}`
    }).then(response => response?.data);
}

export const getTrackedDuration = ({ projectId, taskId, userId, start, end }) => {
    return AjaxService({
        method: 'get',
        url: `time/duration`,
        params: {
            project_id: projectId,
            task_id: taskId,
            user_id: userId,
            start: normalizeDateForServer(start ?? new Date(0)),
            end: normalizeDateForServer(end ?? new Date())
        }
    }).then(response => response?.data);
}
